import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';
import { modules } from '../../shared/order.module';

@Component({
  selector: 'topup-dialog',
  imports: [modules],
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class TopUpDialogComponent implements OnInit, OnDestroy {
  public form!: FormGroup;
  isLoading: boolean = false;
  profilesAreLoading: boolean = false;
  taxiData = null;
  configForm!: FormGroup;

  topupOptions = [];

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<TopUpDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    public fb: FormBuilder
  ) {
    console.log('TOP UP DATA ==> ', data);

    this.topupOptions = data?.value ?? [];

    if (!this.topupOptions || !Array.isArray(this.topupOptions)) {
      console.log('AUTO CLOSE DIALOG !!!!!');
      this.dialogRef.close();
    }
  }

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  async ngOnInit(): Promise<void> {}

  searchKeyPress(event: KeyboardEvent) {
    console.log('KEY PRESS EVENT ==> ', event);
    const pattern = /[0-9]/;
    const inputChar = event.key;
    if (
      /^[0-9.]+$/.test(inputChar) ||
      /^[a-zA-Z]+$/.test(inputChar) ||
      event.code === 'Space' ||
      event.code === 'Backspace' ||
      event.key === 'Backspace' ||
      event.key === '-' ||
      event.code === 'ArrowLeft' ||
      event.code === 'ArrowRight' ||
      event.code === 'Period' ||
      event.code === 'Comma'
    ) {
      console.log('A NUMBER ????1!!');
    } else {
      event.preventDefault();
    }
  }

  cancelReasonSelected($event: any) {
    let value = $event?.value;
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  selectThisOption(amount: any) {
    console.log('SELECTED AMOUNT --> ', amount);
    this.dialogRef.close({ success: true, amount });
  }

  // public onSubmit() {
  //   if (this.isLoading || this.form.invalid) {
  //     return;
  //   }

  //   // Open the dialog and save the reference of it
  //   const dialogRef = this._fuseConfirmationService.open(this.configForm.value);

  //   // Subscribe to afterClosed from the dialog reference
  //   dialogRef.afterClosed().subscribe((result) => {
  //     console.log('CHOICE RESULT ==> ', result);
  //     if (result == 'confirmed') {
  //       let formValue = this.form.getRawValue();
  //       this.isLoading = true;
  //       this._taxisService
  //         .cancelAffect(data._id, data.cmdId, formValue)
  //         .subscribe(
  //           (res) => {
  //             this.isLoading = false;
  //             this.dialogRef.close({ success: true });

  //             // Mark for check
  //             this._changeDetectorRef.markForCheck();
  //           },
  //           () => {
  //             this.isLoading = false;
  //             // Mark for check
  //             this._changeDetectorRef.markForCheck();
  //           }
  //         );
  //     }
  //   });
  // }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
